export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_LOGIN_START = "AUTH_LOGIN_START";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_SIGNUP_ERROR = "AUTH_SIGNUP_ERROR";
export const AUTH_SIGNUP = "AUTH_SIGNUP";
export const GET_USER_INFO = "GET_USER_INFO";
export const USER_INFO_ERROR = "USER_INFO_ERROR";
export const USER_UPDATE_INFO_ERROR = "USER_UPDATE_INFO_ERROR";
export const UPDATE_USER_INFO = "UPDATE_USER_INFO";
export const GET_FAQ_INFO = "GET_FAQ_INFO";
export const FAQ_INFO_ERROR = "FAQ_INFO_ERROR";
export const GET_ABOUT_US_INFO = "GET_ABOUT_US_INFO";
export const ABOUT_US_INFO_ERROR = "ABOUT_US_INFO_ERROR";
export const GET_CONTACT_US_INFO = "GET_CONTACT_US_INFO";
export const CONTACT_US_INFO_ERROR = "CONTACT_US_INFO_ERROR";
export const GET_LANDING_PAGE_INFO = "GET_LANDING_PAGE_INFO";
export const LANDING_PAGE_INFO_ERROR = "LANDING_PAGE_INFO_ERROR";
export const CONTACT_US_INFO = "CONTACT_US_INFO";
export const ADD_NEW_PING_POINT = "ADD_NEW_PING_POINT";
export const ADD_NEW_PING_POINT_ERROR = "ADD_NEW_PING_POINT_ERROR";
export const LOCATION_INFO_ERROR = "LOCATION_INFO_ERROR";
export const GET_LOCATION_INFO = "GET_LOCATION_INFO";
export const LOCATION_FILTER_INFO_ERROR = "LOCATION_FILTER_INFO_ERROR";
export const GET_LOCATION_FILTER_INFO = "GET_LOCATION_FILTER_INFO";

export const ADD_FAVOURITE_INFO = "ADD_FAVOURITE_INFO";
export const ADD_FAVOURITE_ERROR = "ADD_FAVOURITE_ERROR";
export const LIST_FAVOURITE = "LIST_FAVOURITE";
export const LIST_FAVOURITE_ERROR = "LIST_FAVOURITE_ERROR";
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR";
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const UPDATE_CATEGORY_ERROR = "UPDATE_CATEGORY_ERROR";
export const UPDATE_TRAVEL = "UPDATE_TRAVEL";
export const UPDATE_TRAVEL_ERROR = "UPDATE_TRAVEL_ERROR";
export const GET_FILTER_DATA_INFO = "GET_FILTER_DATA_INFO";
export const FILTER_DATA_INFO_ERROR = "FILTER_DATA_INFO_ERROR";
export const UPDATE_POSTAL_CODE = "UPDATE_POSTAL_CODE";
export const UPDATE_POSTAL_CODE_ERROR = "UPDATE_POSTAL_CODE_ERROR";
export const LOCATION_SEARCH_INFO = "LOCATION_SEARCH_INFO";
export const LOCATION_SEARCH_ERROR = "LOCATION_SEARCH_ERROR";

export const TNC_INFO_ERROR = "TNC_INFO_ERROR";
export const GET_TNC_INFO = "GET_TNC_INFO";

export const privacy_policy_INFO = "privacy_policy_INFO";
export const privacy_policy_ERROR = "privacy_policy_ERROR";